import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SubscriptionStatusesByBusiness } from "subModule/src/services/subscriptionplans/interface";
import { RootState } from "app/store";

type SubscriptionState = {
  items: SubscriptionStatusesByBusiness[];
  loaded: boolean;
  hasPlan: boolean;
};

const initialState: SubscriptionState = {
  items: [],
  loaded: false,
  hasPlan: false,
};

const subscriptionSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    setSubscriptionStatuses: (
      _state,
      action: PayloadAction<{
        items: SubscriptionStatusesByBusiness[];
        hasPlan: boolean;
      }>,
    ) => ({
      items: action.payload.items,
      loaded: true,
      hasPlan: action.payload.hasPlan,
    }),
    clearSubscriptionStatuses: () => initialState,
  },
});

export const { setSubscriptionStatuses, clearSubscriptionStatuses } =
  subscriptionSlice.actions;
export default subscriptionSlice.reducer;

export const subscriptionStatusesInfo = (state: RootState) =>
  state.subscriptions.items;

export const selectSubscriptionPlanMeta = (state: RootState) => ({
  loaded: state.subscriptions.loaded,
  hasPlan: state.subscriptions.hasPlan,
});
